import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import Layout from '../components/Layout';
import { contentService } from '../services/firebaseService';
import { AboutContent } from '../types';
import AudioPlayer from '../components/AudioPlayer';

const AboutPage: React.FC = () => {
  const [content, setContent] = useState<AboutContent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const aboutContent = await contentService.getAboutContent();
      setContent(aboutContent);
    } catch (error) {
      console.error('Error loading about content:', error);
    } finally {
      setLoading(false);
    }
  };

  // Default content if Firebase doesn't have it yet
  const defaultContent: AboutContent = {
    aroundTheWorld: 'Communities are facing rising levels of polarization, stress, and conflict. While many efforts focus on resolving conflict after it has escalated, research across psychology, education, and peace studies consistently shows that peace is most effectively built by cultivating the skills, mindsets, and relationships that prevent conflict in the first place. This is the heart of peace education.',
    peaceEducationIntro: 'Peace education equips people with the ability to understand their own needs, communicate effectively, regulate emotions, and empathize across differences. Studies from UNESCO, the Global Partnership for the Prevention of Armed Conflict, and numerous academic programs have affirmed that peace education contributes to:',
    benefits: [
      'Reduced interpersonal and community violence',
      'Improved emotional resilience and self-regulation',
      'Greater social cohesion and empathy across cultures',
      'Increased capacity for collaboration and conflict transformation'
    ],
    conclusion: 'When people learn concrete tools for connection and compassion, they are better able to navigate differences, de-escalate tensions, and create environments where everyone\'s needs matter. In this way, peace education is not simply a curriculum — it is a strategy for transforming the cultural roots of our collective challenges.'
  };

  const displayContent = content || defaultContent;

  if (loading) {
    return (
      <Layout>
        <div className="container">
          <p>Loading...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container">
        <h1>About Us</h1>
        
        {/* Temporarily hidden - will show later
        {displayContent.audioUrl && (
          <div style={{ marginBottom: '2rem', padding: '1rem', background: '#f5f5f5', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: '0.5rem' }}>Listen to Our Story</h3>
            <AudioPlayer src={displayContent.audioUrl} />
          </div>
        )}
        */}
        
        {displayContent.aroundTheWorld && (
          <section style={{ marginBottom: '2rem' }}>
            <div 
              className="rich-text-content"
              style={{ lineHeight: '1.8' }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(displayContent.aroundTheWorld, {
                  ADD_ATTR: ['target', 'rel'],
                  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'a', 'blockquote', 'code', 'pre', 'span', 'div'],
                  ALLOWED_ATTR: ['href', 'target', 'rel', 'style', 'class', 'color']
                }).replace(/<a\s+([^>]*href=["'][^"']*["'][^>]*)>/gi, '<a $1 target="_blank" rel="noopener noreferrer">')
              }}
            />
          </section>
        )}
        

      </div>
    </Layout>
  );
};

export default AboutPage;
